import {createContext} from '@chakra-ui/react-context';
import type {Props} from 'chakra-react-select';

export const [AvatarReactSelectProvider, useAvatarReactSelect] = createContext<Pick<Props<any>, 'size'>>({
  name: `AvatarReactSelectContext`,
  hookName: `useAvatarReactSelect`,
});
